module.exports = __webpack_public_path__ + "img/hero-air-02.d2736b97.png";